// removed by extract-text-webpack-plugin
module.exports = {"dimensions":"_1Jmy_DTrUtLoM2M3Fbc4hT"};


//////////////////
// WEBPACK FOOTER
// ./app/dialogs/ContainerNew/style.scss
// module id = 1057
// module chunks = 0